import { ValidateCataGadpGateway } from "../domain/validateCataGadp.gateway";
import { ValidateCataGadpInterface, ValidateCataGadpBatchResponse, ServiceInfoResponse } from "../domain/validateCataGadp.entities";

export class VerifyUseCase {
    constructor(private gate: ValidateCataGadpGateway) {}

    async execute(params: ValidateCataGadpInterface): Promise<number> {
        return this.gate.verify(params);
    }
}

export class VerifyBatchUseCase {
    constructor(private gate: ValidateCataGadpGateway) {}

    async execute(scheduleIds: number[]): Promise<ValidateCataGadpBatchResponse> {
        return this.gate.verifyBatch(scheduleIds);
    }
}

export class GetServiceInfoUseCase {
    constructor(private gate: ValidateCataGadpGateway) {}

    async execute(bplId: number): Promise<ServiceInfoResponse | null> {
        return this.gate.getServiceInfo(bplId);
    }
}